import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar/Sidebar';
import Navbar from '../components/common/Navbar/Navbar';
import MentorDashboard from '../pages/mentor/MentorDashboard';
import MentorOnboarding from '../pages/mentor/MentorOnboarding';
import MentorProjects from '../pages/mentor/MentorProjects';
import MentorClasses from '../pages/mentor/MentorClasses';
import MentorAvailability from '../pages/mentor/MentorAvailability';
import MentorAssignments from '../pages/mentor/MentorAssignments';
import MentorBOM from '../pages/mentor/MentorBOM';
import MentorDisputes from '../pages/mentor/MentorDisputes';
// Same control panel the admins use — the API scopes it to this mentor's students.
import CompetitionWorkflow from '../pages/admin/CompetitionWorkflow';
import MentorInvoice from '../pages/mentor/MentorInvoice';
import ProjectDetails from '../pages/common/ProjectDetails';
import { getMyProjects } from '../services/projectService';
import styles from './Routes.module.css';

const MentorRoutes = () => {
  const [recentProjects, setRecentProjects] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const projects = await getMyProjects();
        setRecentProjects(projects.slice(0, 3));
      } catch (error) {
        console.error('Failed to fetch projects for sidebar:', error);
      }
    };
    fetchProjects();
  }, []);

  const baseMenuItems = [
    { label: 'Dashboard', path: '/mentor/dashboard', icon: 'dashboard' },
    {
      label: 'My Projects', path: '/mentor/projects', icon: 'projects',
      children: [
        { label: 'In Progress', path: '/mentor/projects/in_progress', icon: 'projects' },
        { label: 'Not Started', path: '/mentor/projects/not_started', icon: 'projects' },
        { label: 'Completed', path: '/mentor/projects/completed', icon: 'projects' },
      ],
    },
    { label: 'Classes', path: '/mentor/classes', icon: 'classes' },
    { label: 'Availability', path: '/mentor/availability', icon: 'calendar' },
    { label: 'Assignments', path: '/mentor/assignments', icon: 'assignments' },
    { label: 'Bill of Materials', path: '/mentor/bom', icon: 'materials' },
    { label: 'Competitions', path: '/mentor/competitions', icon: 'competitions' },
    { label: 'Disputes', path: '/mentor/disputes', icon: 'disputes' },
    { label: 'Invoice', path: '/mentor/invoice', icon: 'reports' }
  ];

  const menuItems = [...baseMenuItems];
  
  if (recentProjects.length > 0) {
    menuItems.push({ type: 'header', label: 'Recent Projects' });
    recentProjects.forEach(p => {
      menuItems.push({
        label: p.project_name,
        path: `/mentor/projects/${p.id}`,
        icon: 'projects',
        isSubItem: true
      });
    });
  }

  return (
    <div className={styles.layout}>
      <Sidebar menuItems={menuItems} role="mentor" />
      <div className={styles.mainContent}>
        <Navbar title="COSMIC Mentor" />
        <div className={styles.content}>
          <Routes>
            <Route path="onboarding" element={<MentorOnboarding />} />
            <Route path="dashboard" element={<MentorDashboard />} />
            <Route path="projects" element={<MentorProjects />} />
            <Route path="projects/in_progress" element={<MentorProjects status="in_progress" />} />
            <Route path="projects/not_started" element={<MentorProjects status="not_started" />} />
            <Route path="projects/completed" element={<MentorProjects status="completed" />} />
            <Route path="projects/:projectId" element={<ProjectDetails />} />
            <Route path="classes" element={<MentorClasses />} />
            <Route path="availability" element={<MentorAvailability />} />
            <Route path="assignments" element={<MentorAssignments />} />
            <Route path="bom" element={<MentorBOM />} />
            <Route path="competitions" element={<CompetitionWorkflow />} />
            <Route path="disputes" element={<MentorDisputes />} />
            <Route path="invoice" element={<MentorInvoice />} />
            <Route path="/" element={<Navigate to="dashboard" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default MentorRoutes;
